// extracted by mini-css-extract-plugin
export default {"root":"EmptyList_root__ztUpD","title":"EmptyList_title__Bs4RZ","subTitle":"EmptyList_subTitle__UCcfD"};